import {Download} from "../../services/sincronizacao/download/Download";
import {AbstractUpload} from "../../services/sincronizacao/upload/AbstractUpload";

export class Enviavel {
  upload: AbstractUpload<any>
  texto: string
  sincronizando = false
  nome: string
  ok: boolean

  constructor(up: AbstractUpload<any>, qtde: number) {
    this.upload = up
    this.nome = up.nome
    this.texto = qtde +''
  }
}
